<dgx-components-grid-section>
  <dgx-components-grid-container class="py-8">
    <dgx-components-grid-row>
      <dgx-components-grid-column>
        <dgx-components-content [body]="body" [title]="title" />
      </dgx-components-grid-column>
    </dgx-components-grid-row>

    <dgx-components-grid-row class="mt-6">
      <dgx-components-grid-column>
        <dgx-components-youtube-player
          class="video-list__video video-embed-player"
          [video]="{
            id: videoId,
          }"
          class="video-list__video video-embed-player"
        ></dgx-components-youtube-player>
      </dgx-components-grid-column>
    </dgx-components-grid-row>
  </dgx-components-grid-container>
</dgx-components-grid-section>
